module.exports = __webpack_public_path__ + "static/media/tit_4.98f06444.png";